import { isNil, isEmpty, isNumber } from 'lodash';

export const APP_PROD: boolean = process.env.NODE_ENV === 'production';

export const baseURL = (process.env.NODE_ENV === 'production' ? '' : 'http://vincit.localhost') + '/api/';

//export const baseURL = 'https://atbilst.wer.org.ua/api/';

export function isEmptyOrIsNil($el: any): boolean {
   return isNil($el) || isEmpty(isNumber($el) ? $el.toString() : $el) || $el == 'Invalid date';
}

export const default_language = 'lv';
